export enum StructCapCrmDealSourceType {
  ADVISOR = 'ADVISOR',
  DIRECT_TO_COMPANY = 'DIRECT_TO_COMPANY',
  EXISTING_PORTFOLIO_COMPANY = 'EXISTING_PORTFOLIO_COMPANY',
  INTERNAL = 'INTERNAL',
  INVESTMENT_BANK = 'INVESTMENT_BANK',
  PE_SPONSOR = 'PE_SPONSOR',
  VC_FUND = 'VC_FUND',
  OTHER = 'OTHER'
}

export const StructCapCrmDealSourceTypeLabels: Record<StructCapCrmDealSourceType, string> = {
  [StructCapCrmDealSourceType.INVESTMENT_BANK]: 'Investment Bank',
  [StructCapCrmDealSourceType.ADVISOR]: 'Advisor',
  [StructCapCrmDealSourceType.DIRECT_TO_COMPANY]: 'Direct to Company',
  [StructCapCrmDealSourceType.INTERNAL]: 'Internal',
  [StructCapCrmDealSourceType.EXISTING_PORTFOLIO_COMPANY]: 'Existing Portfolio Company',
  [StructCapCrmDealSourceType.PE_SPONSOR]: 'PE Sponsor',
  [StructCapCrmDealSourceType.VC_FUND]: 'VC Fund',
  [StructCapCrmDealSourceType.OTHER]: 'Other',
};
